export const firstBoxStyle = {
  first : { textAlign: 'center', display: 'flex', flexDirection: 'column' }
  , second : { border: '1px solid black', borderRadius: '1px', p: 1, marginTop: '2em', width: '20%'
    , marginLeft: 'auto', marginRight: 'auto', height: '2em'}
}
